<template lang="pug">
  div(:class="b()" v-if="adviser")
    div(:class="b('fixed-top')").is-hidden-mobile.is-hidden-tablet-only
      rtc-header(
        :home-url="$baseURL()"
      )
      time-remaining(
        :progress="progress"
      )
      rtc-progress-bar(
        :class="b('progress-bar')"
        :value="progress"
      )
    div(ref="chatViewport" :class="b('chat-viewport')")
      rtc-header(
        :home-url="$baseURL()"
      ).is-hidden-desktop
      div(ref="wrapper" :class="b('wrapper')")
        template(v-for="step, idx in steps")
          step(
            ref="steps"
            :step="step"
            :requesting="isRequesting || adviserIsWriting"
            :current="steps.length === idx + 1"
            :has-next-step="hasNextStep"
            :populated-data="populatedData"
            :last-answer="lastAnswer"
            :can-rewind="canRewind"
            :next-button-text="nextButtonText"
            :notification="steps.length === idx + 1 ? notification : null"
            :adviser="adviser"
            @submit-choice="onSubmitChoice"
            @submit-form="onSubmitForm"
            @next-step="onNextStep"
            @previous-step="onPreviousStep"
          )
        adviser-writing(ref="adviserIsWriting" v-show="adviserIsWriting" :avatar="adviser.avatar")
    div(:class="b('trust-column')" ref="trustColumn")
      component(:is="trustBanner" v-if="trustBanner")
</template>

<script>
  import $ from 'jquery';

  import { mapGetters, mapActions } from 'vuex';
  import RtcProgressBar from '@/components/UI/rtc-progress-bar';
  import RtcHeader from '@/components/UI/rtc-header';
  import TimeRemaining from '@/components/UI/time-remaining';

  import { SCROLL_ANIMATION_TIME } from '@/utils/constants';
  import AdviserWriting from './components/adviser-writing';
  import Step from './components/step';

  export default {
    name: 'flower-view',

    data() {
      return {
        stepsLengthOnLastScroll: -1,
      };
    },

    computed: {
      ...mapGetters('flower', [
        'steps',
        'currentStep',
        'progress',
        'product',
        'canRewind',
        'lastAnswer',
        'populatedData',
        'hasNextStep',
        'isRequesting',
        'nextButtonText',
        'notification',
        'adviserIsWriting',
      ]),

      ...mapGetters({
        trustBanner: 'trust/banner',
        adviser: 'adviser/adviser',
      }),
    },

    methods: {
      ...mapActions('flower', ['init', 'sendForm', 'sendChoice', 'goToPreviousStep', 'nextStep']),
      ...mapActions('adviser', { fetchAdviser: 'fetch' }),
      /**
       * Agrega un padding al wrapper para que el step indicado no se
       * vaya a pegar el bottom del viewpor y permitir que el scroll lo pueda centrar
       *
       * @param {NodeElement} step
       */
      addOutsiderAvoidPaddingToWrapper(step) {
        const chatViewportHeight = this.$refs.chatViewport.offsetHeight;
        const paddingBottom = step.offsetHeight < chatViewportHeight ?
          chatViewportHeight - step.offsetHeight :
          24;

        $(this.$refs.wrapper).css({ paddingBottom: `${paddingBottom}px`});
      },

      onSubmitChoice(choice) {
        this.sendChoice(choice);
      },

      onSubmitForm(data) {
        this.sendForm(data);
      },

      onNextStep() {
        this.nextStep();
      },

      onPreviousStep() {
        this.goToPreviousStep();
      },

      onAddStep() {
        this.$nextTick(() => {
          const steps = this.$refs.steps;
          const lastStep = steps[steps.length - 1].$el;

          this.addOutsiderAvoidPaddingToWrapper(lastStep);
          this.scrollToLastStep();
        });
      },

      onRemoveStep() {
        const steps = this.$refs.steps;
        const newCurrentStep = steps[steps.length - 2].$el;
        const removedStepHeight = steps[steps.length - 1].$el.offsetHeight;
        const $ghostNode = $('<div>').addClass('ghost').css({ height: `${removedStepHeight}px` });

        this.addOutsiderAvoidPaddingToWrapper(newCurrentStep);

        /**
         * Agregamos el nodo ghost el cual es del mismo tamaño que la pregunta la cual se
         * va a eliminar con esto permitimos que se haga un scroll suave hacia arriba
         */
        $ghostNode.appendTo(this.$refs.wrapper);

        this.$nextTick(() => {
          this.scrollToLastStep(() => {
            $(this.$refs.wrapper).find('.ghost').remove()
          });
        });
      },

      scrollToLastStep(cb) {
        const steps = this.$refs.steps;
        const lastStep = steps[steps.length - 1].$el;

        /**
         * Offset para mejorar la posicion de la ultima pregunta
         * desktop: trata de mas o menos centrarla para mejorar la visibilidad
         * mobile: deja un gap de 16px con respecto al header
         */
        // Offset para centrar la pregunta o dejar distancia con respecto al header
        const scrollOffset = do{
          if(window.innerWidth < 768) 64
          else this.$refs.chatViewport.offsetHeight * 0.15
        };

        const scrollTop = lastStep.offsetTop - scrollOffset;

        this.stepsLengthOnLastScroll = steps.length;

        $(this.$refs.chatViewport).stop().animate({
          scrollTop,
        }, SCROLL_ANIMATION_TIME, 'swing', cb);
      },

      scrollToadviserIsWriting() {
        const adviserIsWritingNode = this.$refs.adviserIsWriting.$el
        const scrollTop = adviserIsWritingNode.offsetTop - this.$refs.chatViewport.offsetHeight + (adviserIsWritingNode.offsetHeight + 8);

        /**
         * Evitamos un scroll hacia arriba
         */
        if(scrollTop < $(this.$refs.chatViewport).scrollTop()) return;

        $(this.$refs.chatViewport).stop().animate({
          scrollTop,
        }, 300);
      },
    },

    mounted() {
      const { email, product, motive, adviser } = this.$route.query;

      this.fetchAdviser({ adviserId: adviser })
        .then(() => {
          this.init({ email, product, motive});
        });
    },

    watch: {
      steps(newSteps) {
        if(this.stepsLengthOnLastScroll < newSteps.length) this.onAddStep();
        else this.onRemoveStep();
      },

      adviserIsWriting(v) {
        if(!v) return;

        this.$nextTick(() => {
          this.scrollToadviserIsWriting();
        });
      },
    },

    components: {
      RtcProgressBar,
      RtcHeader,
      TimeRemaining,
      Step,
      AdviserWriting,
    },
  };
</script>

<style lang="sass" scoped>
  @import '~@/sass/mixins'

  $trustWidth: 360px

  .flower-view
    display: flex
    flex-direction: column
    height: 100%

    &__chat-viewport
      flex: 1
      overflow-y: scroll
      position: relative

      +desktop
        padding-right: $trustWidth

    &__wrapper
      max-width: 650px
      margin: 0 auto

    .choices
      max-width: 400px
      margin-left: auto
      margin-right: auto

      +desktop
        max-width: 360px
        margin-left: auto
        margin-right: auto

    &__fixed-top
      background-color: white

      +desktop
        padding-right: $trustWidth

    &__trust-column
      display: none

      font-size: 12px
      background-image: $trustColumnGradient
      color: white

      +desktop
        display: block
        position: fixed
        right: 0
        top: 0
        bottom: 0
        width: 300px
        padding: 210px 46px 0 46px
        margin: 0

        z-index: 3

</style>

<style lang="sass">
  @import '~@/sass/mixins'

  .flower-view
    &__trust-column
      .space-bottom
        margin-bottom: 36px

      .big-title
        font-size: 15px

      .logos
        display: flex
        flex-wrap: wrap
        justify-content: spacer-between


      .logo
        height: 21px
        max-width: 90px
        margin: 16px 6px

        img
          filter: brightness(0) invert(1)

      ul
        li
          list-style: disc
          margin-left: 12px
          font-size: 14px
          line-height: 2

    &__progress-bar
      width: 80%
      max-width: 400px
      margin: 1rem auto

      +desktop
        max-width: calc(100% - 54px)
        max-width: 500px

    .step
      margin: 1rem 0 2rem 0

      &:last-child
        margin-bottom: 1rem

      +desktop
        margin: 1rem 0 4rem 0

        &:last-child
          margin-bottom: 3rem
</style>
